import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sgzp-master-unblock',
  templateUrl: './sgzp-master-unblock.component.html',
  styleUrls: ['./sgzp-master-unblock.component.css', '../style/global.css'],
})
export class SgzpMasterUnblockComponent implements OnInit {
  countdown = 10;
  initialize = false;
  @Input()
  clientId: string;
  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      this.initialize = true;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.redirect();
          clearInterval(interval);
        }
      }, 1000);
    }, 1000);
  }

  redirect() {
    location.href = environment.apps[this.clientId].appUrl;
  }

  get logoUrl1() {
    return (
      '/assets/sgzp-master/images/logo-1.svg'
    );
  }

  get logoUrl2() {
    return (
      '/assets/sgzp-master/images/logo-2.svg'
    );
  }

  get appname() {
    return environment.apps[this.clientId].oemConfig?.name || '処方元情報システム';
  }
}
